export const navigation = [
  {
    name: 'Welcome',
    url: '/dashboard',
    icon: 'fa fa-address-book-o',
    badge: {
      variant: 'info',
      text: 'NEW'
    }
  },
  {
    name: 'Register',
    url: '/register',
    icon: 'icon-user'
  },
  {
    name: 'Login',
    url: '/login',
    icon: 'icon-login'
  },
  {
    name: 'Admin',
    url: '/admin',
    icon: 'icon-lock',
    roles: ["Administrators"],
    children: [
      {
        name: 'Email Users',
        url: '/admin/email/send',
        roles: ["Administrators"],
        icon: 'icon-puzzle'
      },
      {
        name: 'Manage Nascar Users',
        url: '/admin/managenascarusers',
        roles: ["Administrators"],
        icon: 'icon-puzzle'
      },
      {
        name: 'Orgs',
        url: '/admin/orgs',
        roles: ["Administrators"],
        icon: 'icon-puzzle'
      },
      {
        name: 'Games',
        url: '/admin/games',
        roles: ["Administrators"],
        icon: 'icon-puzzle'
      },
      {
        name: 'Manage Races',
        url: '/admin/manageraces',
        roles: ["Administrators"],
        icon: 'icon-puzzle'
      },
      {
        name: 'Football Spreads',
        url: '/nflspreadmanager',
        roles: ["Administrators"],
        icon: 'icon-puzzle'
      },
      {
        name: 'User Manager',
        url: '/nflusermanager',
        roles: ["Administrators"],
        icon: 'icon-puzzle'
      }      
    ]
  },
  {
    name: 'Nascar',
    url: '/dashboard',
    icon: 'fa fa-flag-checkered ',
    roles: ["Administrators", "Nascar User"],
    children: [
      {
        name: 'Nascar Picks',
        url: '/nascar',
        roles: ["Administrators", "Nascar User"]
      },
      {
        name: 'Nascar Results',
        url: '/nascarresults',
        roles: ["Administrators", "Nascar User"]
      }
    ]
  },
  {
    name: 'NFL',
    url: '/dashboard',
    icon: 'fa fa-television',
    roles: ["Administrators", "Football User"],
    children: [
      {
        name: 'Football Picks',
        url: '/nfl',
        roles: ["Administrators", "Football User"]
      },
      {
        name: 'Football Results',
        url: '/nflresults',
        roles: ["Administrators", "Football User"]
      }
    ]
  },
  {
    name: 'NFL Admin',
    url: '/dashboard',
    icon: 'icon-lock',
    roles: ["Football Manager"],
    children: [
      {
        name: 'Football Spreads',
        url: '/nflspreadmanager',
        roles: ["Football Manager"]
      },
      {
        name: 'User Manager',
        url: '/nflusermanager',
        roles: ["Football Manager"]
      }      

    ]
  },
  {
    name: 'NFL Admin',
    url: '/dashboard',
    icon: 'icon-lock',
    roles: ["Football Spread Manager"],
    children: [
      {
        name: 'Football Spreads',
        url: '/nflspreadmanager',
        roles: ["Football Spread Manager"]
      }   

    ]
  }

];





// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/_nav.ts